import { BitrixVue } from 'ui.vue';

BitrixVue.component('MobileDoor', {
	data() {
		return {
			fixedActive: false,
		};
	},
	props: ['positionPrice', 'totalAmount', 'basketLength', 'renderImage','previewDoor' ],
	methods: {
		setActive() {
			if (!this.fixedActive) this.fixedActive = true;
			else this.fixedActive = false;
		},
	},
	template: `
<div class="fixed-door" :class="{active:fixedActive}">
    <div class="fixed-door__wrap">
        <div class="fixed-door__left">
            <div class="fixed-door__row fixed-door__current-cost">
                <div class="fixed-door__title">Стоимость двери:</div>
                <div class="fixed-door__price">{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(positionPrice)}}</div>
            </div>
            <div class="fixed-door__row fixed-door__all-cost" v-if="basketLength >= 1 && fixedActive">
                <div class="fixed-door__title">Стоимость дверей:</div>
                <div class="fixed-door__price">{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(totalAmount)}}</div>
            </div>
        </div>
        <div class="fixed-door__right">
            <div class="fixed-door__img">
                <img v-if="renderImage" :src="renderImage" alt="" >
                <img v-if="previewDoor" :src="previewDoor" alt="" >
            </div>
        </div>
        <div class="fixed-door__increase" @click="$emit('increaseImage')"></div>
        <div class="fixed-door__show" @click="setActive()"></div>
    </div>
</div>
`,
});
